import type { CIParityRow } from '../../devenvbootstrap/framework';

type Props = { items?: CIParityRow[] };

export function CIParityPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((item) => (
        <div key={item.check} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <p className="text-sm font-medium">{item.check}</p>
            {item.parity && (
              <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300">
                parity
              </span>
            )}
          </div>
          <div className="mt-2 flex items-center gap-2 text-xs text-slate-500">
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">local: {item.local}</span>
            <span>↔</span>
            <span className="rounded bg-slate-100 px-2 py-0.5 dark:bg-slate-800">ci: {item.ci}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
